export const styles = {
  sortableList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: 0,
    listStyle: 'none',
  },
};
